import { isEligible, getPromotionData, FREE_PRODUCTS_PROMOTION_PROPERTY_KEY, FREE_PRODUCTS_PROMOTION_VERSION_PROPERTY_KEY } from './free-products-promotion.js';

/**
 * Detect additional free products when increase quantity by 1
 * @param {string[]} shopifyHandles - The Shopify product handles, first string is product handle, from second string are collection handles.
 * @returns {import('./free-products-promotion').AdditionalProduct[]} The additional free products.
 */
export function detectAdditionalFreeProductsPromotionV2(shopifyHandles) {
  const flag = document.getElementById('free-products-flag-v2');
  if (!flag) return [];

  const promotionActive = flag.dataset.promotionActive === 'true';
  if (!promotionActive) return [];

  /**
   * @type {number[]}
  */
  const freeProductIds = JSON.parse(flag.dataset.freeProducts || 'null');
  if (!freeProductIds) return [];

  const matchingQuantity = Number.parseInt(flag.dataset.matchingQuantity || '0', 10) || 0;
  if (!freeProductIds || freeProductIds.length - matchingQuantity <= 0) return [];

  const promotionData = getPromotionData(flag);
  if (!promotionData || !isEligible(shopifyHandles, promotionData)) return [];

  const freeProductVariantId = freeProductIds[matchingQuantity];
  if (!freeProductVariantId) return [];

  return [{
    id: freeProductVariantId,
    quantity: 1,
    properties: {
      [FREE_PRODUCTS_PROMOTION_PROPERTY_KEY]: 'Free Gift',
      [FREE_PRODUCTS_PROMOTION_VERSION_PROPERTY_KEY]: 'free-products-v2'
    },
  }];
}

/**
 * Check and revoke the free products
 * @param {string[]} shopifyHandles - The Shopify product handles, first string is product handle, from second string are collection handles.
 * @param {number} quantityChanged - The quantity changed (new quantity - old quantity).
 * @returns {import('./free-products-promotion').AdditionalProduct[]} The additional free products removed.
 */
export function checkAndRevokeFreeProductsPromotionV2(shopifyHandles, quantityChanged) {
  const flag = document.getElementById('free-products-flag-v2');
  if (!flag) return [];
  const active = flag.dataset.promotionActive === 'true';

  const promotionData = getPromotionData(flag);
  if (!promotionData || !isEligible(shopifyHandles, promotionData)) return [];

  /**
   * @type {number[]}
   */
  const freeProductIds = JSON.parse(flag.dataset.freeProducts || 'null');
  if (!freeProductIds) return [];

  const matchingQuantity = Number.parseInt(flag.dataset.matchingQuantity || '0', 10) || 0;
  const remainingQuantity = matchingQuantity + quantityChanged;
  if (remainingQuantity > freeProductIds.length) return [];

  if (active) {
    return freeProductIds.map((id, index) => ({
      id, quantity: index < remainingQuantity ? 1 : 0
    }));
  } else {
    // Consider the case when multiple promotion versions have the same free products.
    return freeProductIds.slice(remainingQuantity).map(id => ({
      id, quantity: 0
    }));
  }

}